export default {"src":"/_next/static/media/vao-suzette.e18679b2.svg","height":122,"width":198,"blurWidth":0,"blurHeight":0};